import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { equipQuality } from 'actions/myself';
import { STANDARD_CATEGORIES, EXPANDED_CATEGORIES } from 'constants/outfits';
import getVisibleQualities from 'selectors/outfit/getVisibleQualities';

import EquippedItem from '../EquippedItem';
import EmptySlot from './EmptySlot';

import EquippedShortlistComponent from './EquippedShortlistComponent';
import ShortlistQualityPicker from './ShortlistQualityPicker';

export class EquippedShortlistContainer extends Component {
  state = {
    category: null,
    isQualityPickerOpen: false,
  }

  handleChoose = ({ id }) => {
    const { dispatch } = this.props;
    dispatch(equipQuality(id));
  }

  handleOpenQualityPicker = (category) => {
    this.setState({
      category,
      isQualityPickerOpen: true,
    });
  }

  handleRequestClose = () => {
    this.setState({
      isQualityPickerOpen: false,
    });
  }

  render = () => {
    const { isExpanded, outfit, qualities } = this.props;
    const { category, isQualityPickerOpen } = this.state;

    const slotNames = isExpanded ? EXPANDED_CATEGORIES : STANDARD_CATEGORIES;
    return (
      <Fragment>
        <EquippedShortlistComponent>
          {slotNames.map((name) => {
            if (outfit[name]) {
              const quality = qualities.find(q => q.id === outfit[name]);
              return (
                <EquippedItem
                  {...quality}
                  key={name}
                  shortlist
                  onOpenQualityPicker={this.handleOpenQualityPicker}
                />
              );
            }
            return (
              <EmptySlot
                key={name}
                name={name}
                onOpenQualityPicker={this.handleOpenQualityPicker}
              />
            );
          })}
        </EquippedShortlistComponent>
        {category && (
          <ShortlistQualityPicker
            category={category}
            isOpen={isQualityPickerOpen}
            onChoose={this.handleChoose}
            onRequestClose={this.handleRequestClose}
          />
        )}
      </Fragment>
    );
  }
}

EquippedShortlistContainer.displayName = 'EquippedShortlistContainer';

const mapStateToProps = state => ({
  isExpanded: state.outfit.isExpanded,
  outfit: state.outfit,
  qualities: getVisibleQualities(state),
});

export default connect(mapStateToProps)(EquippedShortlistContainer);